import styled, { css } from "styled-components";
import { TransitionStatus } from "react-transition-group/Transition";

export const Row = styled.div<{ $status: TransitionStatus }>`
  display: flex;
  align-items: center;
  transition: opacity 400ms ease-in-out;
  opacity: ${({ $status }) => ($status === "entering" || $status === "entered" ? "1" : "0")};
  visibility: ${({ $status }) => ($status === "entering" || $status === "entered" || $status === "exiting" ? "visible" : "hidden")};
  @media screen and (max-width: 960px) {
    justify-content: space-between;
    margin: 5vw 0;
  }
  @media screen and (min-width: 601px) and (max-width: 960px) {
    margin: 30px 0;
  }
  @media screen and (min-width: 961px) {
    justify-content: flex-start;
    margin: 10px 0;
  }
  @media screen and (min-width: 1441px) and (max-width: 1920px) {
    margin: 20px 0;
  }
  @media screen and (min-width: 1921px) {
    margin: 30px 0;
  }

  &:first-child {
    margin-top: 0;
  }
`;
export const Icon = styled.img`
  display: block;
  box-shadow: 0 3px 2px #555;
  @media screen and (max-width: 960px) {
    width: 16vw;
  }
  @media screen and (min-width: 601px) and (max-width: 960px) {
    width: 96px;
  }
  @media screen and (min-width: 961px) {
    width: 80px;
  }
  @media screen and (min-width: 1441px) and (max-width: 1920px) {
    width: 80px;
  }
  @media screen and (min-width: 1921px) {
    width: 100px;
  }
`;
export const BubbleStyle = css`
  @media screen and (max-width: 960px) {
    width: 66vw;
    min-height: 16vw;
  }
  @media screen and (min-width: 601px) and (max-width: 960px) {
    width: 398px;
    min-height: 60px;
  }
  @media screen and (min-width: 961px) {
    width: 600px;
  }
  @media screen and (min-width: 1441px) and (max-width: 1920px) {
    width: 800px;
  }
  @media screen and (min-width: 1921px) {
    width: 800px;
  }
`;
